export const firebaseConfig = {
  apiKey: "AIzaSyDre37gCyrNU_3JLXqzyLJEj0MuwfSZsC8",
  authDomain: "sap-pf.firebaseapp.com",
  databaseURL: "https://sap-pf-default-rtdb.firebaseio.com",
  projectId: "sap-pf",
  storageBucket: "sap-pf.appspot.com",
  messagingSenderId: "910360394431",
  appId: "1:910360394431:web:a760b062e5f9ff4737240a",
};
